type WorkerResourceEntry = {
  name: string;
  initiatorType: string;
  startTime: number;
  duration: number;
  transferSize?: number;
  encodedBodySize?: number;
  decodedBodySize?: number;
  responseStatus?: number;
};

export function getMujocoWorkerResourceEntries(): WorkerResourceEntry[] {
  try {
    if (typeof performance === "undefined" || typeof performance.getEntriesByType !== "function") {
      return [];
    }
    return performance
      .getEntriesByType("resource")
      .filter((entry) => String(entry?.name || "").includes("mujocoWorker.worker"))
      .sort((a, b) => Number(b.startTime || 0) - Number(a.startTime || 0))
      .map((entry) => {
        const resourceEntry = entry as PerformanceResourceTiming;
        return {
          name: String(resourceEntry.name || ""),
          initiatorType: String(resourceEntry.initiatorType || ""),
          startTime: Number(resourceEntry.startTime || 0),
          duration: Number(resourceEntry.duration || 0),
          transferSize: Number(resourceEntry.transferSize || 0),
          encodedBodySize: Number(resourceEntry.encodedBodySize || 0),
          decodedBodySize: Number(resourceEntry.decodedBodySize || 0),
          responseStatus:
            "responseStatus" in resourceEntry
              ? Number(
                  (resourceEntry as PerformanceResourceTiming & { responseStatus?: number })
                    .responseStatus || 0
                )
              : undefined,
        };
      });
  } catch {
    return [];
  }
}

export function getLatestMujocoWorkerResourceUrl(): string {
  return getMujocoWorkerResourceEntries()[0]?.name || "";
}
